module.exports = __webpack_public_path__ + "assets/13c1b6ccb6011fefa26b34093decce5c.png";